// 所有组件的入口

import Button from './button/button.vue';
import ButtonGroup from './button/button-group.vue';
import Icon from './icon/icon.vue';
import Row from './layout/row.vue';
import Col from './layout/col.vue';
import Input from './input';

import Flaw from './flaw';

const conponents = [
  Button,
  Icon,
  ButtonGroup,
  Row,
  Col,
  Input,

  Flaw
];
const install = (Vue) => {
  conponents.forEach((c) => {
    Vue.component(c.name, c);
  });
};

// 有可能是通过script标签引入的
if (typeof window.Vue !== 'undefined') {
  // window环境我们自动调用install方法
  install(Vue);
}

export default {
  install
};